import Image1 from '../../assets/itech1.jpg';

const data = [
  // Mainnet data start

  // Mainnet data end

  // Testnet data Start
  {
    id: 1.1,
    category: 'SIDOARJO',
    image: Image1,
    title: 'Sidoarjo',
    total: 'Jl. Tirta Raya Ruko No. 17 Perumahan Graha Tirta, Pulosari, Kureksari, Waru, Sidoarjo 61256',
    monit: 'https://maps.app.goo.gl/UGia6hcySF5139oNA',
    stake: 'https://maps.app.goo.gl/UGia6hcySF5139oNA',
  },
  {
    id: 1.2,
    category: 'SURABAYA',
    image: Image1,
    title: 'Surabaya',
    total: 'Jl. Karah No.113, Karah, Kec. Jambangan, Surabaya, Jawa Timur 60232',
    monit: 'https://maps.app.goo.gl/tzUGF4gjHjjmkDSs9',
    stake: '',
  },
  {
    id: 1.3,
    category: 'MALANG',
    image: Image1,
    title: 'Malang',
    total: 'Jl. Soekarno Hatta No.9A Lt. 2, Jatimulyo, Kec. Lowokwaru, Kota Malang, Jawa Timur',
    monit: 'https://maps.app.goo.gl/aaB8Qp4dZLUrHVyV6',
    stake: 'https://maps.app.goo.gl/aaB8Qp4dZLUrHVyV6',
  },
  {
    id: 1.4,
    category: 'MOJOKERTO',
    image: Image1,
    title: 'Mojokerto',
    total: 'Jl. Benteng Pancasila No.27, Mergelo, Meri, Kec. Magersari, Kota Mojokerto, Jawa Timur 61314',
    monit: 'https://maps.app.goo.gl/AZLsnPGjsuGCto9R7',
    stake: 'https://maps.app.goo.gl/AZLsnPGjsuGCto9R7',
  },
];

export default data;
